import { memo } from 'react'
import clsx from 'clsx'

import styles from './styles.module.scss'

function TextWrapper({ children, title, className, type, ...rest }) {
  return (
    <div {...rest} data-type={type} title={title} className={clsx(styles.message_content, className)}>
      {children}
    </div>
  )
}

export default memo(TextWrapper)
